module.exports = __webpack_public_path__ + "static/media/share.7ab21eaf.svg";